module.exports = __webpack_public_path__ + "static/media/seguro.64cf1f32.svg";